module.exports = __webpack_public_path__ + "img/1988_L.94b6abc7.png";